const cardSetConstants = {
  GET_ALL_CARDSETS_START: "GET_ALL_CARDSETS_START",
  GET_ALL_CARDSETS_SUCCESS: "GET_ALL_CARDSETS_SUCCESS",
  GET_ALL_CARDSETS_FAILED: "GET_ALL_CARDSETS_FAILED",
  ADD_CARDSET_START: "ADD_CARDSET_START",
  ADD_CARDSET_END: "ADD_CARDSET_END",
  ADD_CARDSET_FAILED: "ADD_CARDSET_FAILED",
  VIEW_CARDSET_START: "VIEW_CARDSET_START",
  VIEW_CARDSET_SUCCESS: "VIEW_CARDSET_SUCCESS",
  VIEW_CARDSET_FAILED: "VIEW_CARDSET_FAILED",
  EDIT_CARDSET_START: "EDIT_CARDSET_START",
  EDIT_CARDSET_END: "EDIT_CARDSET_END",
  EDIT_CARDSET_FAILED: "EDIT_CARDSET_FAILED",
  EDIT_CARDSET_SUCCESS: "EDIT_CARDSET_SUCCESS",
};

export default cardSetConstants;
